"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// Wait a tick to get past the loading state
var _default = exports.default = function _default(ms /*: number*/) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
};
//# sourceMappingURL=nextTick.js.map